import { geoTypeLabel } from '@/Enums/Geography/GeographyType.enum';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { GREY } from '../../../constants/color';

const NotFoundLocationChip = memo(({ locationName, locationType }) => {
  return (
    <div className='flex items-center gap-2 px-3 py-1 border border-[#F95738] rounded-full'>
      <span className='text-[#F95738] text-[14px] font-semibold'>{locationName}</span>
      <span className={`text-[${GREY}] text-[12px]`}>{geoTypeLabel(locationType)}</span>
    </div>
  );
});

NotFoundLocationChip.propTypes = {
  locationName: PropTypes.string,
  locationType: PropTypes.string,
};

export default NotFoundLocationChip;
